export const BASE_URL = process.env.VUE_APP_API_HOST || 'http://localhost:5000/';
export const IS_MZ_BRANDING = (process.env.VUE_APP_IS_MZ_BRANDING || '').toLowerCase() === 'true';
export const SENTRY_ENV = process.env.VUE_APP_SENTRY_ENV || "DEV"
